import { Injectable } from "@angular/core";
import { AsEnumerable, asEnumerable } from "linq-es5";
import { ResultDto } from "./resultDto";
import { IEnumerable } from "linq-es5/lib/enumerable";


@Injectable()
export class ResultCollection {
    // Status: boolean;
    // Message: string;
    // Data: any;

    // constructor(status: boolean = false, message: string = "") {
    //     this.Status = status;
    //     this.Message = message;
    constructor() {
    }

    getResult(Data: IEnumerable<ResultDto>): any{
        var params = AsEnumerable(Data);
        return params;
    }

    getResultAlert(data: IEnumerable<ResultDto>): Array<ResultDto>{
        var params;
        if(data instanceof Array)
            params = AsEnumerable(data).Where(r => r.result == -2).ToArray();

        return params;
    }

    getResultError(data: IEnumerable<ResultDto>): Array<ResultDto>{
        var params;
        if(data instanceof Array)
            params = AsEnumerable(data).Where(r => r.result == -1).ToArray();

        return params;
    }

    getOutMessage(data: IEnumerable<ResultDto>): ResultDto{
        var params = AsEnumerable(data).Where(r => r.result == 1).FirstOrDefault();
        return params;
    }

    getOutParameters(data: IEnumerable<ResultDto>, property: string): ResultDto{
        var params = AsEnumerable(data).Where(r => r.result == 5 && r.mensaje === property).FirstOrDefault();
        return params;
    }

    // getOutParameters(data: IEnumerable<ResultDto>, property: string): any{
    //     var params = AsEnumerable(data).Where(r => r.result == 5 && r.mensaje === property).Select(x => x.identity).FirstOrDefault();
    //     return params;
    // }
}
